import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'utcToLocalTime'
})
export class UtcToLocalTimePipe implements PipeTransform {
    transform(utcDate: Date)
        : Date {
            var newDate = new Date(utcDate);
            const offsetMinutes = newDate.getTimezoneOffset();
            const localTime = new Date(newDate.getTime() - offsetMinutes * 60 * 1000);
            return localTime;
    }
}